import { gql } from "@apollo/client";

export const GET_STORE_CONFIG = gql`
  query {
    storeConfig {
      id
      code
      website_id
      locale
      base_currency_code
      default_display_currency_code
      timezone
      product_url_suffix
      weight_unit
      base_url
      base_link_url
      base_static_url
      base_media_url
      secure_base_url
      secure_base_link_url
      secure_base_static_url
      secure_base_media_url
      store_name
      purpose_of_enquiry
      magento_wishlist_general_is_enabled
      default_title
      default_keywords
      welcome
      default_description
      root_category_id
      support_email
      home_categories
      home_focus_categories
      site_header_text
      support_phone
      navigation_exclude_category
      delivery_text
      max_return_days
      request_type
      product_type
      customer_type
      product_category
      footer_text
      recaptcha_site_key
    }
  }
`;

export default {
  getStoreConfig: GET_STORE_CONFIG,
};
